import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import type { TeacherStat, BranchStat } from "@/hooks/useClassTrialStats";

interface Props {
  teacherStats: TeacherStat[];
  branchStats: BranchStat[];
}

export function TrialStatsCSVExport({ teacherStats, branchStats }: Props) {
  const exportCSV = () => {
    const bom = "\uFEFF";
    let csv = bom;

    // Teacher stats
    csv += "=== สถิติรายครู ===\n";
    csv += "ครู,ทั้งหมด,สำเร็จ,ไม่สำเร็จ,คืนเงิน,ดำเนินการ,อัตรา%\n";
    teacherStats.forEach((t) => {
      csv += `${t.teacherCode},${t.total},${t.success},${t.failure},${t.refund},${t.inProgress},${t.conversionRate.toFixed(1)}\n`;
    });

    csv += "\n=== สถิติรายสาขา ===\n";
    csv += "สาขา,ทั้งหมด,สำเร็จ,ไม่สำเร็จ,คืนเงิน\n";
    branchStats.forEach((b) => {
      csv += `${b.branch},${b.total},${b.success},${b.failure},${b.refund}\n`;
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `trial-stats-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Button variant="outline" size="sm" onClick={exportCSV}>
      <Download className="h-4 w-4 mr-1" />
      Export CSV
    </Button>
  );
}
